import type {ComplianceCreativeProgressStatus} from '~/graphql-react-query/graphql';

export const COMPLIANCE_NOTE_MAX_LENGTH = 250;

export const DEFAULT_COMPLIANCE_PROGRESS_STATUS: ComplianceCreativeProgressStatus = 'pendingReview';

export const COMPLIANCE_PROGRESS_STATUSES: readonly ComplianceCreativeProgressStatus[] = [
    'pendingReview',
    'underInvestigation',
    'furtherReviewRequired',
    'safeAndComplete'
] as const;

export function getComplianceProgressStatusLabel(status: ComplianceCreativeProgressStatus): string {
    switch (status) {
        case 'pendingReview':
            return 'Pending review';
        case 'underInvestigation':
            return 'Under investigation';
        case 'furtherReviewRequired':
            return 'Further review required';
        case 'safeAndComplete':
            return 'Safe and complete';
    }
}

export function getComplianceProgressStatusColorKey(
    status: ComplianceCreativeProgressStatus
): 'background3' | 'yellow' | 'red' | 'green' {
    switch (status) {
        case 'safeAndComplete':
            return 'green';
        case 'furtherReviewRequired':
            return 'red';
        case 'underInvestigation':
            return 'yellow';
        case 'pendingReview':
            return 'background3';
    }
}

export function humanizeComplianceHistorySummary(summary: string): string {
    let result = summary;
    for (const status of COMPLIANCE_PROGRESS_STATUSES) {
        result = result.replaceAll(status, getComplianceProgressStatusLabel(status));
    }
    return result;
}
